import React, { useEffect, useState } from 'react';
import MasterLayout from '../../layouts/MasterLayout';
import ThemeBreadcrumb from '../../components/themes/ThemeBreadcrumb';
import AppNotification from '../../helpers/AppNotification';
import Paginate from '../../components/paginate/Paginate';
import Swal from 'sweetalert2';
import CodeMoneyModel from '../../models/CodeMoneyModel';
import { useDispatch } from 'react-redux';
import { setShowPreloader } from '../../redux/action';
import { Modal, Button } from 'react-bootstrap';

function CreateCodeMoney(props) {
    const dispatch = useDispatch();
    const [items, setItems] = useState([]);
    const [meta, setMeta] = useState({});
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [keyword, setKeyword] = useState({
        denominations: '',
        quantity: '1',
        percent: '',
        days: '30',
    });
    const [keywordSearch, setKeywordSearch] = useState({
        denominationsSearch: '',
        statusSearch: '',
    });

    const [filter, setFilter] = useState({
        search: '',
        perPage: perPage,
        page: page,
    });

    // 0: Code tiền / hoàn tiền, 1: Giảm giá %, 2: Code lượt VIP theo ngày
    const [selectedType, setSelectedType] = useState(0);

    const handleSelectType = (e) => {
        const value = parseInt(e.target.value, 10);
        setSelectedType(value);
    };

    const changePage = (page) => {
        setPage(page);
        setFilter({ search: keywordSearch });
    };

    const loadData = () => {
        CodeMoneyModel.getCode({
            search: filter.search,
            page: page,
            perPage: perPage
        })
            .then(res => {
                setItems(res.data || []);
                setMeta(res.meta || {});
            }).catch(err => {
                console.log(err);
                AppNotification.showError('Lấy dữ liệu thất bại!');
            });
    };

    useEffect(() => {
        loadData();
    }, [page, filter]);

    const handleChange = (event) => {
        setKeyword({
            ...keyword,
            [event.target.name]: event.target.value
        });
    };

    const handleSubmit = () => {
        // Validation trước khi gửi
        if (!keyword.quantity || parseInt(keyword.quantity, 10) <= 0) {
            Swal.fire({
                icon: "warning",
                title: "Vui lòng nhập số lượng sử dụng lớn hơn 0!",
            });
            return;
        }

        if (selectedType === 0) {
            const denom = parseInt((keyword.denominations || '').replace(/[^0-9]/g, ''), 10);
            if (!denom || denom < 1000) {
                Swal.fire({
                    icon: "warning",
                    title: "Mệnh giá tiền nạp phải từ 1.000 VNĐ trở lên!",
                });
                return;
            }
        } else if (selectedType === 1) {
            const pct = parseInt((keyword.percent || '').replace(/[^0-9]/g, ''), 10);
            if (!pct || pct <= 0 || pct >= 100) {
                Swal.fire({
                    icon: "warning",
                    title: "Tỷ lệ giảm giá phải từ 1% đến 99%!",
                });
                return;
            }
        } else if (selectedType === 2) {
            const d = parseInt((keyword.days || '').replace(/[^0-9]/g, ''), 10);
            if (!d || d <= 0) {
                Swal.fire({
                    icon: "warning",
                    title: "Số ngày VIP phải lớn hơn 0!",
                });
                return;
            }
        }

        dispatch(setShowPreloader(true));
        CodeMoneyModel.createCode({
            quantity: keyword.quantity,
            denominations: keyword.denominations,
            selectedType: selectedType,
            percent: keyword.percent,
            days: keyword.days,
        })
            .then((res) => {
                dispatch(setShowPreloader(false));
                if (res.success === true) {
                    Swal.fire({
                        icon: "success",
                        title: res.message || "Tạo mã code thành công!",
                        showConfirmButton: true,
                    });
                    // Reset input
                    setKeyword(prev => ({
                        ...prev,
                        denominations: '',
                        percent: '',
                        quantity: '1',
                    }));
                    loadData();
                } else {
                    Swal.fire({
                        icon: "error",
                        title: res.message || "Tạo code thất bại!",
                    });
                }
            }).catch(err => {
                dispatch(setShowPreloader(false));
                console.log(err);
                Swal.fire({
                    icon: "error",
                    title: "Có lỗi xảy ra khi tạo code!",
                });
            });
    };

    const handleChangeSearch = (event) => {
        const val = event.target.value;
        const newSearch = {
            ...keywordSearch,
            [event.target.name]: val
        };
        setKeywordSearch(newSearch);
        setPage(1);
        setFilter({ search: newSearch });
    };

    const handleSetPage = (number) => {
        setPage(page + number);
        setFilter({ search: keywordSearch });
    };

    const handleDeleteCode = (id) => {
        Swal.fire({
            title: "Xác nhận xoá mã Code này?",
            text: "Dữ liệu lịch sử sử dụng của mã này cũng sẽ được dọn dẹp.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ef4444",
            cancelButtonColor: "#64748b",
            confirmButtonText: "Đồng ý xoá",
            cancelButtonText: "Huỷ"
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(setShowPreloader(true));
                CodeMoneyModel.delete({ id: id })
                    .then((res) => {
                        dispatch(setShowPreloader(false));
                        if (res.success) {
                            Swal.fire({
                                icon: "success",
                                title: "Xoá Code thành công!",
                                showConfirmButton: false,
                                timer: 1500,
                            });
                            loadData();
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: res.message || "Xoá Code thất bại!",
                            });
                        }
                    })
                    .catch((err) => {
                        dispatch(setShowPreloader(false));
                        console.log(err);
                        AppNotification.showError("Xoá Code thất bại!");
                    });
            }
        });
    };

    const [show, setShow] = useState(false);
    const [historyData, setHistoryData] = useState([]);

    const handleClose = () => setShow(false);
    const HandleShowModel = (id) => {
        dispatch(setShowPreloader(true));
        CodeMoneyModel.histories(id)
            .then((res) => {
                dispatch(setShowPreloader(false));
                setHistoryData(res.data || []);
                setShow(true);
            })
            .catch((err) => {
                dispatch(setShowPreloader(false));
                console.log(err);
                setHistoryData([]);
                setShow(false);
                AppNotification.showError("Không lấy được lịch sử sử dụng");
            });
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        Swal.fire({
            icon: "success",
            title: "Đã copy: " + text,
            showConfirmButton: false,
            timer: 1000,
        });
    };

    // Tính toán quy đổi lượt/ngày hiển thị thời gian thực cho Admin
    const vipDays = parseInt(keyword.days, 10) || 0;
    const vipSlots = Math.floor(vipDays / 30);
    const vipRemainder = vipDays % 30;

    return (
        <MasterLayout>
            <ThemeBreadcrumb title="Tạo Mã Code" />
            <div className='row'>
                <div className="col-lg-4 col-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title"> Tạo Code Mới</h4>
                        </div>
                        <div className="card-body">
                            <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                                <div className='input-group mb-3'>
                                    <div className='row w-100'>
                                        <div className='col-12 mb-3'>
                                            <label className='text-warning font-weight-bold'>Loại code: </label>
                                            <select
                                                name="type" 
                                                value={selectedType} 
                                                onChange={handleSelectType}
                                                className="form-control form-control-new"
                                            >
                                                <option value="0">💰 Code hoàn tiền (Nạp số dư VNĐ)</option>
                                                <option value="2">👑 Code lượt theo ngày (VIP)</option>
                                                <option value="1">🏷️ Code giảm giá (%)</option>
                                            </select>
                                        </div>

                                        {selectedType === 0 && (
                                            <div className='col-12 mb-3'>
                                                <label className='text-warning font-weight-bold'>Mệnh giá nạp (VNĐ): </label>
                                                <input
                                                    type='text'
                                                    name='denominations'
                                                    className='form-control'
                                                    placeholder='Ví dụ: 250000'
                                                    value={keyword.denominations}
                                                    onChange={handleChange}
                                                />
                                                <div className="d-flex gap-1 mt-2 flex-wrap">
                                                    {[50000, 100000, 200000, 500000, 1000000].map(val => (
                                                        <button 
                                                            key={val} 
                                                            type="button" 
                                                            className="badge badge-light border text-dark" 
                                                            style={{cursor: 'pointer'}}
                                                            onClick={() => setKeyword(k => ({...k, denominations: val.toString()}))}
                                                        >
                                                            {val.toLocaleString()}đ
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        {selectedType === 1 && (
                                            <div className='col-12 mb-3'>
                                                <label className='text-warning font-weight-bold'>Tỷ lệ giảm giá (%): </label>
                                                <input
                                                    type='text'
                                                    name='percent'
                                                    className='form-control'
                                                    placeholder='Ví dụ: 20'
                                                    value={keyword.percent}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        )}

                                        {selectedType === 2 && (
                                            <div className='col-12 mb-3'>
                                                <label className='text-warning font-weight-bold'>Số ngày VIP: </label>
                                                <input
                                                    type='text'
                                                    name='days'
                                                    className='form-control'
                                                    placeholder='Ví dụ: 30'
                                                    value={keyword.days}
                                                    onChange={handleChange}
                                                />

                                                {/* Box tính toán cẩn thận */}
                                                <div 
                                                    className="p-2 mt-2 rounded" 
                                                    style={{ 
                                                        background: 'var(--wus-success-bg)', 
                                                        border: '1px solid var(--wus-success-border)',
                                                        fontSize: '12.5px',
                                                        color: 'var(--wus-success-text)'
                                                    }}
                                                >
                                                    <div>⚡ <strong>Quy đổi:</strong> {vipSlots} lượt VIP {vipRemainder > 0 ? `+ ${vipRemainder} ngày lẻ` : ''}</div>
                                                    <div style={{fontSize: '11px', color: 'var(--wus-text-muted)'}}>
                                                        (Quy tắc chuẩn: 1 lượt = 30 ngày VIP)
                                                    </div>
                                                </div>

                                                <div className="d-flex gap-1 mt-2 flex-wrap">
                                                    {[
                                                        { label: '30 ngày (1 lượt)', days: 30 },
                                                        { label: '60 ngày (2 lượt)', days: 60 },
                                                        { label: '90 ngày (3 lượt)', days: 90 },
                                                        { label: '180 ngày (6 lượt)', days: 180 },
                                                        { label: '365 ngày (12 lượt)', days: 365 },
                                                    ].map(item => (
                                                        <button 
                                                            key={item.days} 
                                                            type="button" 
                                                            className="badge badge-light border text-dark" 
                                                            style={{cursor: 'pointer'}}
                                                            onClick={() => setKeyword(k => ({...k, days: item.days.toString()}))}
                                                        >
                                                            {item.label}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>
                                        )}

                                        <div className='col-12 mb-3'>
                                            <label className='text-warning font-weight-bold'>Số lượng sử dụng (lượt dùng): </label>
                                            <input
                                                type='number'
                                                name='quantity'
                                                className='form-control'
                                                min="1"
                                                placeholder='Nhập số lượng sử dụng...'
                                                value={keyword.quantity}
                                                onChange={handleChange}
                                            />
                                            <small className="text-muted" style={{fontSize: '11.5px'}}>
                                                Mỗi user chỉ được dùng mã này 1 lần cho đến khi hết {keyword.quantity || 1} lượt dùng.
                                            </small>
                                        </div>

                                        <div className='col-12 d-flex justify-content-center mt-2'>
                                            <button 
                                                className='btn btn-primary w-100 py-2' 
                                                type='button'
                                                onClick={handleSubmit}
                                                style={{fontWeight: '600'}}
                                            >
                                                ✨ Tạo Mã Code
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div className="col-lg-8 col-12">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <h4 className="card-title mb-0"> Mã Code Đã Tạo</h4>
                            <span className="badge badge-primary">{meta.total || items.length} mã trong hệ thống</span>
                        </div>
                        <div className="card-body">
                            <div className='row d-flex justify-content-end mb-3'>
                                <div className='col-lg-12'>
                                    <div className='input-group'>
                                        <input
                                            type='text'
                                            name='denominationsSearch'
                                            className='form-control'
                                            placeholder='Tìm kiếm theo Code, mệnh giá, số ngày...'
                                            value={keywordSearch.denominationsSearch}
                                            onChange={handleChangeSearch}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='table-responsive'>
                                <table className="table header-border table-responsive-sm">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Code</th>
                                            <th>Loại</th>
                                            <th>Mệnh giá / Giá trị</th>
                                            <th>Trạng thái</th>
                                            <th>Hành động</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.length === 0 ? (
                                            <tr>
                                                <td colSpan="6" className="text-center py-4 text-muted">
                                                    Chưa có mã Code nào được tạo
                                                </td>
                                            </tr>
                                        ) : (
                                            items.map((item, key) => (
                                                <tr key={key}>
                                                    <td>{item.id}</td>
                                                    <td>
                                                        <button 
                                                            className="badge badge-info"
                                                            style={{cursor: 'pointer', fontFamily: 'monospace', fontSize: '13px'}}
                                                            onClick={() => HandleShowModel(item.id)}
                                                            title="Click để xem lịch sử sử dụng"
                                                        >
                                                            {item.code}
                                                        </button>
                                                    </td>
                                                    <td>
                                                        {item.type === 0 && (
                                                            <span className="badge badge-primary">💰 Code hoàn tiền</span>
                                                        )}
                                                        {item.type === 1 && (
                                                            <span className="badge badge-warning">🏷️ Giảm giá</span>
                                                        )}
                                                        {item.type === 2 && (
                                                            <span className="badge badge-success">
                                                                👑 Lượt VIP theo ngày
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {item.type === 0 && (
                                                            <span style={{ fontWeight: 700, color: 'var(--wus-text)', fontFamily: 'var(--wus-mono)' }}>{item.denominations_fm} VNĐ</span>
                                                        )}
                                                        {item.type === 1 && (
                                                            <span style={{ fontWeight: 700, color: 'var(--wus-warning-text)' }}>{item.percentage}%</span>
                                                        )}
                                                        {item.type === 2 && (
                                                            <span style={{ fontWeight: 700, color: 'var(--wus-success-text)' }}>
                                                                +{item.days} ngày (~ {Math.floor((item.days || 0) / 30)} lượt)
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {item.quantity > 0 ? (
                                                            <span className="badge badge-success">
                                                                Còn hạn (còn {item.quantity})
                                                            </span>
                                                        ) : (
                                                            <span className="badge badge-danger">Hết lượt</span>
                                                        )}
                                                    </td>

                                                    <td>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <button 
                                                                className="btn btn-xs btn-danger"
                                                                onClick={() => handleDeleteCode(item.id)}
                                                            >
                                                                Xoá
                                                            </button>

                                                            <button 
                                                                className="btn btn-xs btn-secondary"
                                                                onClick={() => copyToClipboard(item.code)}
                                                                title="Copy mã code"
                                                            >
                                                                Copy
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                                <Paginate meta={meta} changePage={changePage} page={page} handleSetPage={handleSetPage}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal size="lg" centered show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Lịch sử sử dụng mã Code</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='table-responsive' style={{maxHeight: '300px', overflowY: 'auto'}}>
                        <table className="table header-border table-responsive-sm">
                            <thead>
                                <tr>
                                    <th>STT</th>
                                    <th>User</th>
                                    <th>Code</th>
                                    <th>Thời gian sử dụng</th>
                                </tr>
                            </thead>
                            <tbody>
                                {historyData.length === 0 ? (
                                    <tr>
                                        <td colSpan="4" className="text-center py-3 text-muted">
                                            Mã này chưa được ai sử dụng
                                        </td>
                                    </tr>
                                ) : (
                                    historyData.map((item, key) => (
                                        <tr key={key}>
                                            <td>{key + 1}</td>
                                            <td>{item.user_name}</td>
                                            <td><code>{item.code}</code></td>
                                            <td>{item.created_at}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Đóng
                    </Button>
                </Modal.Footer>
            </Modal>

        </MasterLayout>
    );
}

export default CreateCodeMoney;
